import {
  Component,
  Input,
  OnInit,
  ViewChild,
  AfterViewInit,
  SimpleChanges,
  OnChanges
} from "@angular/core";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { IOsaExecucaoFolhaTesteModel } from '../../../../../models/osa-execucao-folha-teste-model';
import { OsaExecucaoAbaFolhaTesteQuestaoComponent } from "./../osa-execucao-aba-folha-teste-questao/osa-execucao-aba-folha-teste-questao.component";
import { OsaExecucaoFolhaTesteService } from '../../../../../services/osa-execucao-folha-teste.service';
import Swal from "sweetalert2";
import { OsaExecucaoAbaFolhaTesteCancelarComponent } from "../osa-execucao-aba-folha-teste-cancelar/osa-execucao-aba-folha-teste-cancelar.component";
import { AuthService } from "../../../../../services/auth.service";
import { OsaExecucaoAbaFolhaTesteImprimirComponent } from "../osa-execucao-aba-folha-teste-imprimir/osa-execucao-aba-folha-teste-imprimir.component";

@Component({
  selector: 'app-osa-execucao-aba-folha-teste-lista',
  templateUrl: './osa-execucao-aba-folha-teste-lista.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-lista.component.scss']
})
export class OsaExecucaoAbaFolhaTesteListaComponent implements OnInit, AfterViewInit, OnChanges {

  constructor(
    private osaExecucaoFolhaTesteService: OsaExecucaoFolhaTesteService,
    private matDialog: MatDialog,
    public router: Router,
    public authService: AuthService,
    public route: ActivatedRoute) {
  }

  public displayedColumns: string[] = [
    'numeroFolha',
    'amostraItemDescricao',
    'dataFinalizado',
    'nomeResponsavelFinalizado',
    'status',
    'acoes'
  ];

  @Input() listaDados: IOsaExecucaoFolhaTesteModel[] = [] as IOsaExecucaoFolhaTesteModel[];
  @Input() osaExecucaoId!: number;
  @Input() unidadeGestoraId!: number;
  @Input() amostraId!: number;
  @Input() visualizar: boolean = false;
  @Input() numeroOsa!: string;
  @Input() statusProgramaTrabalho: number = 1;
  //-> Crit 21/23: true com Matriz Preliminar Finalizada/Aprovada/Rejeitada (bloqueia ações)
  @Input() bloqueadoPorMatriz: boolean = false;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  public dataSource: MatTableDataSource<IOsaExecucaoFolhaTesteModel> = new MatTableDataSource();

  ngOnInit(): void {
    this.atualizarLista();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.listaDados || changes.unidadeGestoraId || changes.amostraId || changes.osaExecucaoId) {
      this.atualizarLista();
    }
  }

  private atualizarLista(): void {
    this.dataSource = new MatTableDataSource(this.listaDados);
    if (this.sort && this.paginator) {
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    }
    this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
  }

  public routeIncludes(tipoTrabalho: string) {
    return this.router.url.includes(tipoTrabalho);
  }

  public sortingDataAccessor = (item: IOsaExecucaoFolhaTesteModel, property) => {
    switch (property) {
      case "numeroFolha":
        return item?.numeroFolha;
      case "amostraItemDescricao":
        return item?.amostraItemDescricao;
      case "dataFinalizado":
        return item?.dataFinalizado;
      case "nomeResponsavelFinalizado":
        return item?.nomeResponsavelFinalizado;
      case "status":
        return item?.status;
      default:
        return item[property];
    }
  };

  public modalQuestao(titulo: string, visualizar: boolean, element?: IOsaExecucaoFolhaTesteModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-folha-teste-questao";
    dialogConfig.width = "90vw";
    dialogConfig.maxHeight = "90vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      titulo,
      visualizar,
      numeroOsa: this.numeroOsa,
      osaExecucaoId: this.osaExecucaoId,
      id: element?.id,
      element
    };
    const modal = this.matDialog.open(
      OsaExecucaoAbaFolhaTesteQuestaoComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.atualizarListaNaVolta()
      }
    });
  }

  public modalCancelar(element?: IOsaExecucaoFolhaTesteModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-folha-teste-questao";
    dialogConfig.width = "60vw";
    dialogConfig.maxHeight = "60vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: element?.id,
      element
    };
    const modal = this.matDialog.open(
      OsaExecucaoAbaFolhaTesteCancelarComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((data) => {
      if (data) {
        this.atualizarListaNaVolta()
      }
    });
  }

  atualizarListaNaVolta() {
    this.osaExecucaoFolhaTesteService
      .obterFolhaTestePorExecucaoUnidadeGestoraAmostra(this.osaExecucaoId, this.unidadeGestoraId, this.amostraId)
      .then((res) => {
        this.listaDados = res.dados as IOsaExecucaoFolhaTesteModel[];
        this.atualizarLista();
      })
      .catch((err) => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: err?.mensagem?.descricao || 'Erro ao carregar dados',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      });
  }


  public habilitar(element: IOsaExecucaoFolhaTesteModel) {

    Swal.fire({
      title: "Habilitar Folha Teste",
      text: "Deseja remover o cancelamento da Folha teste e habilitar a folha teste para preenchimento?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.value) {

        const responsavelId = this.authService.usuario.id;
        element.responsavelIdHab = responsavelId;
        element.status = 2;

        this.osaExecucaoFolhaTesteService
          .habilitarFolhaTeste(element)
          .then((res) => {
            if (res.sucesso) {

              this.atualizarListaNaVolta();

              Swal.fire({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: "success",
                text: res.mensagem.descricao,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          }).finally(() => {
          });
      }
    })
  }

  public excluir(element: IOsaExecucaoFolhaTesteModel) {

    Swal.fire({
      title: "Excluir Folha Teste",
      text: "Deseja excluir a Folha teste ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then((res) => {

      if (res.value) {

        this.osaExecucaoFolhaTesteService
          .excluirFolhaTeste(element.id)
          .then((res) => {
            if (res.sucesso) {

              this.atualizarListaNaVolta();

              Swal.fire({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                icon: "success",
                text: res.mensagem.descricao,
              });
            } else {
              Swal.fire({
                toast: true,
                position: "top-end",
                icon: "warning",
                text: res.mensagem.descricao,
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            }
          }).finally(() => {
          });
      }
    })
  }

  public imprimir(element?: IOsaExecucaoFolhaTesteModel) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-folha-teste-imprimir";
    dialogConfig.width = "90vw";
    dialogConfig.maxHeight = "90vh";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      numeroOsa: this.numeroOsa,
      id: element?.id,
      element
    };
    const modal = this.matDialog.open(
      OsaExecucaoAbaFolhaTesteImprimirComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((data) => {
    });
  }

  formatarTooltipCanc(element: any): string {

    const data = element?.dataHoraCanc
      ? new Date(element.dataHoraCanc).toLocaleDateString('pt-BR')
      : 'Data não informada';

    const nome = element?.nomeResponsavelCanc || 'Usuário desconhecido';
    const comentario = element?.justificativaCanc || 'Sem comentário';

    return `🗓 ${data}\n👤 ${nome}\n💬 ${comentario}`;
  }
}
